
import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import Tag from '@/components/common/tag/tag';
import GreyTick from "@/assets/icons/greyTick.png"
import BlackDropDown from "@/assets/icons/blackDropDown.png";
import WhiteDropDown from "@/assets/icons/whiteDropDown.png"
import BlackUnFilledHeart from "@/assets/icons/blackUnFilledHeart.png"
import WhiteUnFillerHeart from "@/assets/icons/whiteUnFillerHeart.png"
import BlackShare from "@/assets/icons/blackShare.png"
import WhiteShare01 from "@/assets/icons/whiteShare01.png"

import RedFilledHeart from "@/assets/icons/redFilledHeart.png"


import "./style.css"
import { themes } from '@/constants/colors_v2';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function SeriesListMainView(props: any) {
    const { common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    console.log("props.serie", props.serie)
    return (
        <div className="seriesListMainView">
            <button
                className="flex items-center w-full"
                onClick={props.onToggle}
            >
                <div className="w-full text-left mr-[1px]">
                    <p className="moduleHeading1 mb-[5px]">{common.statusText.module}{' '}{props.serieIndex + 1}</p>
                    <p className="moduleHeading2">{props.serie.sectionTitle}</p>
                </div>

                <img
                    className={`w-[14px] transition-transform duration-300 ${props.isOpen ? "rotate-360" : "rotate-180"}`}
                    src={currentTheme === themes.dark ? WhiteDropDown : BlackDropDown}
                    alt="BlackDropDown"
                />
            </button>

            {props.isOpen && (
                <div className="seriesContentCon">
                    {props.serie.videos.map((video: any, videoIndex: number) => (
                        <div
                            id={`seriesContentCon_videoId_${video._id}`}
                            onClick={() => props.changeVideo(video._id)}
                            key={videoIndex}
                            style={{
                                opacity: props.videoChangingId === video._id ? 0.5 : 1,
                                cursor: props.videoChangingId === video._id ? 'not-allowed' : 'pointer',
                                // backgroundColor: (props.currentVideoId === video._id) ? '#EAF4FF' : 'white'
                            }}
                            className={`flex seriesContentCon1 ${props.currentVideoId === video._id ? 'seriesContentConInView' : 'seriesContentConNotInView'}`}>
                                
                            <img
                                className="thumbnailUrl"
                                src={video.thumbnailUrl} alt="thumbnailUrl" />

                            <div className="flex flex-col justify-center">
                                <p className="videoTitle">{video.title}</p>

                                <div className="flex items-center mt-[6px]">
                                    {video.isFavourite ? (
                                        <button
                                            style={{
                                                cursor: props.whichFavBtnIsLoading === video._id ? "not-allowed" : "pointer",
                                                opacity: props.whichFavBtnIsLoading === video._id ? 0.6 : 1,
                                            }}
                                            className="mr-[5px]"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                props.handleVideoFavBtnClick(video._id)
                                            }}
                                            disabled={props.whichFavBtnIsLoading === video._id}>
                                            <img
                                                src={RedFilledHeart}
                                                className="w-[15px]"
                                                alt="RedFilledHeart" />
                                        </button>
                                    ) : (
                                        <button
                                            style={{
                                                cursor: props.whichFavBtnIsLoading === video._id ? "not-allowed" : "pointer",
                                                opacity: props.isFavBtnLoading ? 0.6 : 1,
                                            }}
                                            className="mr-[5px]"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                props.handleVideoFavBtnClick(video._id, props.serie.seriesId)
                                            }}
                                            disabled={props.whichFavBtnIsLoading === video._id}>
                                            <img
                                                src={currentTheme === themes.dark ? WhiteUnFillerHeart : BlackUnFilledHeart}
                                                className="w-[15px]"
                                                alt="BlackUnFilledHeart" />
                                        </button>
                                    )}
                                    <img
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            props.handleShare()
                                        }}
                                        src={currentTheme === themes.dark ? WhiteShare01 : BlackShare}
                                        className="w-[15px] cursor-pointer"
                                        alt="BlackShare" />


                                    {video.isWatched &&
                                        <div className='w-fit ml-[8px]'>
                                            <Tag
                                                text={common.statusText.watchedTag}
                                                icon={GreyTick}
                                                colorCode="grey"
                                                borderR_tl="5px"
                                                borderR_tr="5px"
                                                borderR_bl="5px"
                                                borderR_br="5px"
                                                iconWidth="14px"
                                                borderWidth="0.5px"
                                                textSize="11px"
                                                textWeight="500"
                                                padding_left="4px"
                                                padding_top="3px"
                                                padding_right="4px"
                                                padding_bottom="3px"
                                                line_hight="17px"
                                            />
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
